export default __webpack_public_path__ + "256d900ea986ef908a476a8abc9f74b8.png";